// import React from "react";
// import Footer from "../Screenss/Footer";
// const  Directormsg = () => {
//   const primaryColor = "rgb(0,111,47)";

//   return (
//     <div style={{ fontFamily: "sans-serif", background: "#f8fafc" }}>
      
//       {/* 🔥 HERO BANNER */}
//       <div style={styles.hero}>
//         <img
//           src="https://images.unsplash.com/photo-1588072432836-e10032774350"
//           alt="School Banner"
//           style={styles.heroImg}
//         />
//         <div style={styles.overlay}></div>

//         <div style={styles.heroContent}>
//           <h1>We Build the Citizens of Tomorrow</h1>
//           <p>Principal's Message</p>
//         </div>
//       </div>

//       {/* 🔥 MAIN SECTION */}
//       <div style={styles.container}>

//         <div style={styles.row}>
          
//           {/* 👩‍🏫 LEFT IMAGE */}
//           <div style={styles.imageWrapper}>
//             <img
//               src="https://images.unsplash.com/photo-1607746882042-944635dfe10e"
//               alt="Principal"
//               style={styles.principalImg}
//             />
//             <div style={styles.nameBox}>
//               <h3>Mrs. Deepti Vadhera</h3>
//               <p>Principal</p>
//             </div>
//           </div>

//           {/* 📜 RIGHT CONTENT */}
//           <div style={styles.card}>
//             <h2 style={{ color: primaryColor }}>
//               Principal's Message
//             </h2>

//             <p>
//               Welcome to <b>Delhi Public Kids School</b> — a symbol of progressive,
//               purposeful, and quality education.
//             </p>

//             <p>
//               Our motto, <b>"We build the citizens of tomorrow,"</b> reflects our
//               commitment to nurturing not just academic excellence but overall
//               development in sports, arts, and co-curricular activities.
//             </p>

//             <p>
//               Our school proudly offers activities like Football, Basketball,
//               Cricket, Badminton, Skating, and more — shaping students into
//               confident and active individuals.
//             </p>

//             <p>
//               At the heart of our institution is a team of dedicated teachers
//               who see teaching not just as a profession, but as a passion.
//             </p>

//             <p>
//               Our aim is to make education joyful, meaningful, and value-based —
//               ensuring every child grows with happiness and confidence.
//             </p>

//             <p style={{ marginTop: "20px", fontWeight: "600" }}>
//               Mrs. Deepti Vadhera <br />
//               Principal, Delhi Public Kids School, Ladwa
//             </p>
//           </div>

//         </div>
//       </div>
//       <Footer/>
//     </div>
//   );
// };

// // const styles = {
// //   hero: {
// //     position: "relative",
// //     height: "380px",
// //   },
// //   heroImg: {
// //     width: "100%",
// //     height: "100%",
// //     objectFit: "cover",
// //   },
// //   overlay: {
// //     position: "absolute",
// //     inset: 0,
// //     background: "linear-gradient(rgba(0,111,47,0.7), rgba(0,0,0,0.7))",
// //   },
// //   heroContent: {
// //     position: "absolute",
// //     top: "50%",
// //     left: "50%",
// //     transform: "translate(-50%, -50%)",
// //     color: "#fff",
// //     textAlign: "center",
// //   },

// //   container: {
// //     maxWidth: "1200px",
// //     margin: "auto",
// //     padding: "60px 20px",
// //   },
// // row: {
// //   display: "flex",
// //   gap: "50px",
// //   alignItems: "stretch",   // 🔥 center ki jagah stretch (match height)
// //   flexWrap: "wrap",
// // },
// // //   row: {
// // //     display: "flex",
// // //     gap: "50px",
// // //     alignItems: "center",
// // //     flexWrap: "wrap",
// // //   },

// // //   imageWrapper: {
// // //     position: "relative",
// // //     flex: "1",
// // //     minWidth: "280px",
// // //   },
// // imageWrapper: {
// //   position: "relative",
// //   flex: "1.2",   // 🔥 pehle 1 tha → ab image thodi badi hogi
// //   minWidth: "320px",
// // },
// // //   principalImg: {
// // //     width: "100%",
// // //     borderRadius: "20px",
// // //     boxShadow: "0 15px 40px rgba(0,0,0,0.1)",
// // //   },
// // principalImg: {
// //   width: "100%",
// //   height: "100%",              // 🔥 full height lega
// //   minHeight: "420px",          // 🔥 content ke barabar feel
// //   objectFit: "cover",
// //   borderRadius: "20px",
// //   boxShadow: "0 15px 40px rgba(0,0,0,0.1)",
// // },
// //   nameBox: {
// //     position: "absolute",
// //     bottom: "10px",
// //     left: "10px",
// //     background: "rgba(0,0,0,0.7)",
// //     color: "#fff",
// //     padding: "10px 15px",
// //     borderRadius: "10px",
// //   },

// //   card: {
// //     flex: "1.5",
// //     background: "#fff",
// //     padding: "35px",
// //     borderRadius: "20px",
// //     boxShadow: "0 10px 30px rgba(0,0,0,0.05)",
// //     lineHeight: "1.8",
// //   },
// // };

// // export default  Directormsg;

// const styles = {
//   hero: {
//     position: "relative",
//     height: "clamp(220px, 40vw, 380px)", // 🔥 responsive height
//   },

//   heroImg: {
//     width: "100%",
//     height: "100%",
//     objectFit: "cover",
//   },

//   overlay: {
//     position: "absolute",
//     inset: 0,
//     background: "linear-gradient(rgba(0,111,47,0.7), rgba(0,0,0,0.7))",
//   },

//   heroContent: {
//     position: "absolute",
//     top: "50%",
//     left: "50%",
//     transform: "translate(-50%, -50%)",
//     color: "#fff",
//     textAlign: "center",
//     padding: "0 clamp(10px, 4vw, 20px)", // 🔥 mobile safe
//   },

//   container: {
//     maxWidth: "1200px",
//     margin: "auto",
//     padding: "clamp(30px, 6vw, 60px) 15px", // 🔥 responsive padding
//   },

//   row: {
//     display: "flex",
//     gap: "clamp(20px, 5vw, 50px)", // 🔥 responsive gap
//     alignItems: "stretch",
//     flexWrap: "wrap",
//     justifyContent: "center", // 🔥 spacing fix
//   },

//   imageWrapper: {
//     position: "relative",
//     flex: "1 1 420px", // 🔥 responsive flex
//     minWidth: "280px",
//     width: "100%", // 🔥 spacing fix
//   },

//   principalImg: {
//     width: "100%",
//     height: "100%",
//     minHeight: "clamp(260px, 40vw, 420px)", // 🔥 responsive
//     objectFit: "cover",
//     borderRadius: "20px",
//     boxShadow: "0 15px 40px rgba(0,0,0,0.1)",
//   },

//   nameBox: {
//     position: "absolute",
//     bottom: "10px",
//     left: "10px",
//     background: "rgba(0,0,0,0.7)",
//     color: "#fff",
//     padding: "clamp(8px, 2vw, 12px) clamp(12px, 3vw, 15px)", // 🔥 responsive
//     borderRadius: "10px",
//     fontSize: "clamp(12px, 2vw, 14px)",
//   },

//   card: {
//     flex: "1 1 420px", // 🔥 equal width
//     background: "#fff",
//     padding: "clamp(20px, 4vw, 35px)", // 🔥 responsive
//     borderRadius: "20px",
//     boxShadow: "0 10px 30px rgba(0,0,0,0.05)",
//     lineHeight: "1.8",
//     fontSize: "clamp(13px, 2vw, 15px)", // 🔥 responsive text
//     width: "100%", // 🔥 spacing fix
//   },
// };

// export default Directormsg;

//  import React from "react";
// import Footer from "../Screenss/Footer";

// const Directormsg = () => {
//   const primaryColor = "rgb(0,111,47)";

//   return (
//     <div style={styles.page}>
      
//       {/* 🔥 HERO */}
//       <div style={styles.hero}>
//         <img
//           src="https://images.unsplash.com/photo-1588072432836-e10032774350"
//           alt="School Banner"
//           style={styles.heroImg}
//         />
//         <div style={styles.overlay}></div>

//         <div style={styles.heroContent}>
//           <h1 style={styles.heroTitle}>We Build the Citizens of Tomorrow</h1>
//           <p style={styles.heroSub}>Director's Message</p> {/* 🔥 changed */}
//         </div>
//       </div>

//       {/* 🔥 MAIN */}
//       <div style={styles.container}>
//         <div style={styles.row}>

//           {/* 👤 IMAGE */}
//           <div style={styles.imageWrapper}>
//             <img
//               src="https://dpsladwa.com/Dpsschool_Data/uploads/images/1776679570_69e5fa92dc3c2.jpg"
//               alt="Director"
//               style={styles.principalImg}
//             />
//             <div style={styles.nameBox}>
//               <h3 style={{ margin: 0 }}>Mr. Rajan Vadhera</h3>
//               <p style={{ margin: 0, fontSize: "13px" }}>Director</p>
//             </div>
//           </div>

//           {/* 📜 CONTENT */}
//           <div style={styles.card}>
//             <h2 style={{ color: primaryColor, marginBottom: "10px" }}>
//               Director Message
//             </h2>

//             <p>
//               With a deep love for education and a true passion for nurturing young minds,
//               I have always believed that the quality of childhood education has a direct
//               and lasting impact on a child’s life.
//             </p>

//             <p>
//               It was this conviction that led me to build a school that does more than teach —
//               a school that listens, encourages, supports, and walks hand-in-hand with every
//               child through those precious early years.
//             </p>

//             <p>
//               At DPS Kids Ladwa, we are committed to assuring every parent that their child is
//               safe, happy, growing, and surrounded by people who genuinely care.
//             </p>

//             <p>
//               Our motto, <b>“Light of the World”</b>, came from deep reflection. A true light never
//               runs out of energy. It stands out in darkness. It leads, illuminates, and endures.
//               That is exactly what we aim to give every child who walks through our doors.
//             </p>

//             <p>
//               We are grateful to every family who has trusted us with their most precious treasure.
//             </p>

//             <p style={styles.signature}>
//               Mr. Rajan Vadhera <br />
//               Director, Delhi Public Kids School, Ladwa
//             </p>
//           </div>

//         </div>
//       </div>

//       <Footer />
//     </div>
//   );
// };

// export default Directormsg;

// /* 🔥 STYLES */
// const styles = {
//   page: {
//     fontFamily: "sans-serif",
//     background: "#f8fafc",
//   },

//   hero: {
//     position: "relative",
//     height: "clamp(220px, 40vw, 380px)",
//   },

//   heroImg: {
//     width: "100%",
//     height: "100%",
//     objectFit: "cover",
//   },

//   overlay: {
//     position: "absolute",
//     inset: 0,
//     background: "linear-gradient(rgba(0,111,47,0.7), rgba(0,0,0,0.7))",
//   },

//   heroContent: {
//     position: "absolute",
//     top: "50%",
//     left: "50%",
//     transform: "translate(-50%, -50%)",
//     textAlign: "center",
//     color: "#fff",
//     padding: "0 15px",
//   },

//   heroTitle: {
//     fontSize: "clamp(20px, 5vw, 38px)",
//     fontFamily: 'sans-serif',
//     fontWeight: "800",
//     marginBottom: "6px",
//   },

//   heroSub: {
//     fontSize: "clamp(13px, 2vw, 16px)",
//     opacity: 0.9,
//     fontFamily: 'sans-serif',
//   },

//   container: {
//     maxWidth: "1200px",
//     margin: "auto",
//     padding: "clamp(30px, 6vw, 60px) 15px",
//   },

//   row: {
//     display: "flex",
//     gap: "clamp(20px, 5vw, 50px)",
//     flexWrap: "wrap",
//     alignItems: "stretch",
//     justifyContent: "center",
//   },

//   imageWrapper: {
//     flex: "1 1 420px",
//     minWidth: "280px",
//     position: "relative",
//   },

//   principalImg: {
//     width: "100%",
//     height: "100%",
//     minHeight: "clamp(260px, 40vw, 420px)",
//     objectFit: "cover",
//     borderRadius: "20px",
//     boxShadow: "0 15px 40px rgba(0,0,0,0.1)",
//   },

//   nameBox: {
//     position: "absolute",
//     bottom: "10px",
//     left: "10px",
//     background: "rgba(0,0,0,0.7)",
//     color: "#fff",
//     padding: "10px 14px",
//     borderRadius: "10px",
//     fontSize: "13px",
//   },

//   card: {
//     flex: "1 1 420px",
//     background: "#fff",
//     padding: "clamp(20px, 4vw, 35px)",
//     borderRadius: "20px",
//     boxShadow: "0 10px 30px rgba(0,0,0,0.05)",
//     lineHeight: "1.8",
//     fontSize: "clamp(13px, 2vw, 15px)",
//   },

//   signature: {
//     marginTop: "20px",
//     fontWeight: "600",
//   },
// };

 import React, { useContext, useEffect, useState } from "react";
import { DataContext } from "../Screenss/DataContext";

const Directormsg = () => {
  const primaryColor = "rgb(0,111,47)";
const { data } = useContext(DataContext);
 const [current, setCurrent] = useState(0);
const galleryItems = data.filter(
    (item) => item.category === "ourschool"
  );

  // 🔁 Auto Slide
  useEffect(() => {
    if (galleryItems.length === 0) return;

    const interval = setInterval(() => {
      setCurrent((prev) =>
        prev === galleryItems.length - 1 ? 0 : prev + 1
      );
    }, 3000); // 3 sec

    return () => clearInterval(interval);
  }, [galleryItems]);
  return (
    <div style={styles.page}>
      
      {/* 🔥 HERO */}
      {/* <div style={styles.hero}>
        <img
          src="https://images.unsplash.com/photo-1588072432836-e10032774350"
          alt="School Banner"
          style={styles.heroImg}
        />
        <div style={styles.overlay}></div>

        <div style={styles.heroContent}>
          <h1 style={styles.heroTitle}>
            We Build the Citizens of Tomorrow
          </h1>
          <p style={styles.heroSub}>Director's Message</p>
        </div>
      </div> */}
  <section style={styles.hero}>
        <div style={styles.heroImageWrap}>
          
          {galleryItems.length > 0 && (
            <img
              src={galleryItems[current].full_url}
              alt="school banner"
              style={styles.heroImage}
            />
          )}

          <div style={styles.heroOverlay} />

          {/* <div style={styles.heroContent}>
            <h1 style={styles.heroTitle}>
              Building Foundations That Last a Lifetime
            </h1>
            <p style={styles.heroText}>
              A school is more than walls and textbooks — it is where futures are shaped, values are rooted, and dreams take flight.
            </p>
          </div> */}

          {/* ✅ Dots Indicator */}
          <div style={styles.dots}>
            {galleryItems.map((_, i) => (
              <span
                key={i}
                onClick={() => setCurrent(i)}
                style={{
                  ...styles.dot,
                  backgroundColor:
                    current === i ? "rgb(0,111,47)" : "#fff",
                }}
              />
            ))}
          </div>

        </div>
      </section>
      {/* 🔥 MAIN */}
      <div style={styles.container}>
        <div style={styles.row}>

          {/* 👤 IMAGE */}
          <div style={styles.imageWrapper}>
            <img
              src="https://dpsladwa.com/Dpsschool_Data/uploads/images/1776679570_69e5fa92dc3c2.jpg"
              alt="Director"
              style={styles.principalImg}
            />
            <div style={styles.nameBox}>
              <h3 style={styles.name}>Mr. Rajan Vadhera</h3>
              <p style={styles.role}>Director</p>
            </div>
          </div>

          {/* 📜 CONTENT */}
          <div style={styles.card}>
            <h2 style={{ ...styles.heading, color: primaryColor }}>
              Director Message
            </h2>

            <p style={styles.text}>
              With a deep love for education and a true passion for nurturing young minds,
              I have always believed that the quality of childhood education has a direct
              and lasting impact on a child’s life.
            </p>

            <p style={styles.text}>
              It was this conviction that led me to build a school that does more than teach —
              a school that listens, encourages, supports, and walks hand-in-hand with every
              child through those precious early years.
            </p>

            <p style={styles.text}>
              At DPS Kids Ladwa, we are committed to assuring every parent that their child is
              safe, happy, growing, and surrounded by people who genuinely care.
            </p>

            <p style={styles.text}>
              Our motto, <b>“Light of the World”</b>, came from deep reflection. A true light never
              runs out of energy. It stands out in darkness. It leads, illuminates, and endures.
              That is exactly what we aim to give every child who walks through our doors.
            </p>

            <p style={styles.text}>
              We are grateful to every family who has trusted us with their most precious treasure.
            </p>

            <p style={styles.signature}>
              Mr. Rajan Vadhera <br />
              Director, Delhi Public Kids School, Ladwa
            </p>
          </div>

        </div>
      </div>
 
    </div>
  );
};

export default Directormsg;

/* 🔥 STYLES */
const styles = {
  page: {
    fontFamily: "sans-serif",
    background: "#f8fafc",
  },

  /* HERO */
  
  hero: {
    width: "100%",
    marginTop: "clamp(80px, 10vw, 120px)", // 🔥 responsive
  },

  heroImageWrap: {
    position: "relative",
    width: "100%",
    height: "clamp(280px, 50vw, 560px)", // 🔥 FIXED HEIGHT → responsive
    overflow: "hidden",
    marginTop: "clamp(60px, 8vw, 140px)", // 🔥 responsive spacing
  },

  heroImage: {
    width: "100%",
    height: "100%",
    objectFit: "cover",
    display: "block",
  },

  heroOverlay: {
    position: "absolute",
    inset: 0,
    background: "rgba(0,0,0,0.45)",
  },

  heroContent: {
    position: "absolute",
    inset: 0,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    textAlign: "center",
    color: "#fff",
    padding: "0 clamp(12px, 4vw, 20px)", // 🔥 responsive padding
  },

  heroTitle: {
    fontSize: "clamp(24px, 5vw, 48px)", // 🔥 responsive
    fontWeight: "800",
    marginBottom: "12px",
    maxWidth: "900px",
  },

  heroText: {
    maxWidth: "760px",
    fontSize: "clamp(13px, 2vw, 18px)", // 🔥 responsive
    opacity: 0.92,
  },

  /* MAIN */
  container: {
    maxWidth: "1200px",
    margin: "auto",
    padding: "clamp(30px, 6vw, 70px) 15px",
  },

  row: {
    display: "flex",
    gap: "clamp(20px, 5vw, 50px)",
    flexWrap: "wrap",
    alignItems: "stretch",
    justifyContent: "center",
  },

  /* IMAGE */
  imageWrapper: {
    flex: "1 1 420px",
    minWidth: "280px",
    position: "relative",
  },

  principalImg: {
    width: "100%",
    height: "100%",
    minHeight: "clamp(260px, 40vw, 420px)",
    objectFit: "cover",
    borderRadius: "20px",
    boxShadow: "0 15px 40px rgba(0,0,0,0.1)",
  },

  nameBox: {
    position: "absolute",
    bottom: "12px",
    left: "12px",
    background: "rgba(0,0,0,0.75)",
    color: "#fff",
    padding: "10px 14px",
    borderRadius: "10px",
  },

  name: {
    margin: 0,
    fontSize: "14px",
    fontWeight: "600",
  },

  role: {
    margin: 0,
    fontSize: "12px",
    opacity: 0.8,
  },

  /* CARD */
  card: {
    flex: "1 1 420px",
    background: "#fff",
    padding: "clamp(20px, 4vw, 35px)",
    borderRadius: "20px",
    boxShadow: "0 10px 30px rgba(0,0,0,0.05)",
  },

  heading: {
    fontSize: "clamp(20px, 3vw, 28px)",
    fontWeight: "700",
    marginBottom: "10px",
  },

  text: {
    fontSize: "clamp(13px, 2vw, 16px)",
    lineHeight: "1.8",
    color: "#4b5563",
    marginBottom: "12px",
  },

  signature: {
    marginTop: "20px",
    fontWeight: "600",
    color: "#111",
  },
};